import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zoom_out",
  "use": "zoom_out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"zoom_out\"><path d=\"M13.5 9H6v1.5h7.5z\" /><path d=\"M16.086 15A8.14 8.14 0 0 0 18 9.75 8.25 8.25 0 1 0 9.75 18 8.14 8.14 0 0 0 15 16.086l5.69 5.664 1.06-1.06zM9.75 16.5a6.75 6.75 0 1 1 6.75-6.75 6.76 6.76 0 0 1-6.75 6.75\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol